import { trainingHelps } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { ITrainingHelps } from "../../models/master/trainingHelp";

export default new (class TrainingHelpService {
  public getTrainingHelp = async (id: number): Promise<IApiResponse<ITrainingHelps>> => {
    try {
      let endPoint = urlBinder(trainingHelps.GET_TRAINING_HELP, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<ITrainingHelps>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<ITrainingHelps>;
      } else {
        throw error;
      }
    }
  };

  public getTrainingHelps = async (
    pageBlock?: number,
    noOfItems?: number,
    configUserType?: number
  ): Promise<IApiResponse<Array<ITrainingHelps>>> => {
    try {
      let endPoint = urlBinder(trainingHelps.GET_ALL_TRAINING_HELPS, [pageBlock,noOfItems,configUserType]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<ITrainingHelps>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<ITrainingHelps>>;
      } else {
        throw error;
      }
    }
  };

  public createTrainingHelp = async (
    data: any
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = trainingHelps.CREATE_TRAINING_HELP;
      const response = await APIService.postFormData(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public updateTrainingHelp = async (
    data: any,
    id: number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(trainingHelps.UPDATE_TRAINING_HELP, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public updateTrainingHelpPriority = async (
    data: any
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = trainingHelps.UPDATE_TRAINING_HELP_PRIORITY;
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteTrainingHelp = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(trainingHelps.DELETE_TRAINING_HELP, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };
})();
